<template>
  <!-- <el-dialog
    class="examine-detail"
    title="详情"
    :visible="detailShow"
    width="600px"
    center
    :close-on-click-modal="false"
    @open="dialogOpen"
    @close="dialogClose"
  >
  </el-dialog> -->
  <div class="examine-detail">
    <el-dialog
      title="内容"
      :visible="detailShow"
      width="30%"
      @open="dialogOpen"
      @close="dialogClose"
    >
      <!-- <span>{{ examineDetail.content }}</span> -->
      <div style="white-space: pre-line">{{ examineDetail.content }}</div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="showDetail">取 消</el-button> -->
        <el-button type="primary" @click="showDetail">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    detailShow: {
      type: Boolean,
      default: false,
    },
    examineDetail: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      imgList: [],
    };
  },
  created() {
    //  console.log(this.examineDetail);
  },
  computed: {},
  methods: {
    dialogOpen() {
      if (this.examineDetail.imgList && this.examineDetail.imgList.length) {
        this.imgList = this.examineDetail.imgList.split(",");
      }
    },
    dialogClose() {
      this.imgList = [];
      this.$emit("update:detailShow", false);
    },
    showDetail() {
      this.$emit("showDetail", false);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./examine-detail.scss";
</style>